import BatchJobsModule from '@/lib/api/modules/batch-jobs';
import FileModule from '@/lib/api/modules/file';
import HelpContentModule from '@/lib/api/modules/help-content';
import InfraModule from '@/lib/api/modules/infra';
import LabsModule from '@/lib/api/modules/labs';
import OmicsRunsModule from '@/lib/api/modules/omics-runs';
import OmicsWorkflowsModule from '@/lib/api/modules/omics-workflows';
import OrgsModule from '@/lib/api/modules/orgs';
import SeqeraPipelinesModule from '@/lib/api/modules/seqera-pipelines';
import SeqeraRunsModule from '@/lib/api/modules/seqera-runs';
import UploadsModule from '@/lib/api/modules/uploads';
import UsersModule from '@/lib/api/modules/users';

export const api = {
  batchJobs: new BatchJobsModule(),
  file: new FileModule(),
  helpContent: new HelpContentModule(),
  infra: new InfraModule(),
  labs: new LabsModule(),
  omicsRuns: new OmicsRunsModule(),
  omicsWorkflows: new OmicsWorkflowsModule(),
  orgs: new OrgsModule(),
  seqeraPipelines: new SeqeraPipelinesModule(),
  seqeraRuns: new SeqeraRunsModule(),
  uploads: new UploadsModule(),
  users: new UsersModule(),
};
